import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GetGift } from './gift-voucher.interface';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConvertService } from 'src/app/services/convert.service';
import { AlertService } from 'src/app/services/alert.service';
import moment from 'moment';
import { Router } from '@angular/router';
import { AppURL } from 'src/app/app.url';

@Component({
  selector: 'app-gift-voucher',
  templateUrl: './gift-voucher.component.html',
  styleUrls: ['./gift-voucher.component.scss']
})
export class GiftVoucherComponent {
  contentGift = environment.contentGift
  constructor(private http: HttpClient,
    private fb: FormBuilder,
    private con: ConvertService,
    private alert: AlertService,
    private router: Router
  ) {
    this.getGift();
  }
  formGift: FormGroup | any = this.fb.group(<GetGift>{
    ID: "",
    Name: "",
    Type: "",
    Image: "",
    Image_delete: "",
    Image_update: "",
    DisType: "",
    DisAmount: 0,
    Amount: 0,
    Condition: "",
    Expire: 0,
    Expire_start_edit: "",
    Expire_end_edit: "",
    Expire_start: "",
    Expire_end: "",
  })

  giftItems!: GetGift[]
  pageTotal: number = 0
  getGift(v?: any) {
    let uri: string = `gift?page=${v?.page || 1}&limit=15`
    if (v?.value) {
      uri = `gift?search=${v.value}&page=${v?.page || 1}&limit=15`
    }
    this.http.get(uri).subscribe({
      next: (res: any) => {
        this.giftItems = res.data
        this.pageTotal = res.pageTotal
      }
    })
  }
  imageAction: boolean = false
  setitem: any = [];
  viewMenu(items: any, elm: any, v: any) {
    let model: any[] = [];
    model.push({ label: 'ส่งบัตรกำนัล', command: () => this.sendGift(items) });
    model.push({ label: 'แก้ไข', command: () => this.viewGift(items) });
    model.push({ label: 'ลบ', command: () => this.deleteGift(items) });
    this.setitem = model;
    elm.toggle(v);
  }

  setDateDefault() {
    this.formGift.get('Expire').setValue(1)
    let dateStart: string = ""
    let editStart: string = ""
    let dateEnd: string = ""
    let editEnd: string = ""
    // START
    editStart = moment(new Date()).format('DD/MM/YYYY')
    this.formGift.get('Expire_start_edit').setValue(editStart)
    dateStart = moment(new Date()).format('YYYY-MM-DD')
    this.formGift.get('Expire_start').setValue(dateStart)

    // END
    editEnd = moment(new Date()).format('DD/MM/YYYY')
    this.formGift.get('Expire_end_edit').setValue(editEnd)
    dateEnd = moment(new Date()).format('YYYY-MM-DD')
    this.formGift.get('Expire_end').setValue(dateEnd)
  }

  setDate(item: GetGift) {
    let dateStart: string = ""
    let editStart: string = ""
    let dateEnd: string = ""
    let editEnd: string = ""
    // START
    editStart = moment(new Date()).format('DD/MM/YYYY')
    this.formGift.get('Expire_start_edit').setValue(editStart)
    dateStart = moment(new Date()).format('YYYY-MM-DD')
    this.formGift.get('Expire_start').setValue(dateStart)

    // END
    editEnd = moment(new Date()).format('DD/MM/YYYY')
    this.formGift.get('Expire_end_edit').setValue(editEnd)
    dateEnd = moment(new Date()).format('YYYY-MM-DD')
    this.formGift.get('Expire_end').setValue(dateEnd)

    if (item.Expire_start) {
      editStart = moment(item.Expire_start).format('DD/MM/YYYY')
      this.formGift.get('Expire_start_edit').setValue(editStart)
      dateStart = moment(item.Expire_start).format('YYYY-MM-DD')
      this.formGift.get('Expire_start').setValue(dateStart)
    }
    if (item.Expire_end) {
      editEnd = moment(item.Expire_end).format('DD/MM/YYYY')
      this.formGift.get('Expire_end_edit').setValue(editEnd)
      dateEnd = moment(item.Expire_end).format('YYYY-MM-DD')
      this.formGift.get('Expire_end').setValue(dateEnd)
    }
  }



  message: string = ""
  manageGift: boolean = false
  addStatus: boolean = false;
  addGift() {
    this.message = "เพิ่มบัตรกำนัล"
    this.manageGift = true
    this.addStatus = true;
    this.setDateDefault()
  }

  updateStatus: boolean = false;
  updateItems!: GetGift
  viewGift(item: GetGift) {
    if (item.Image) this.imageAction = true
    this.formGift.patchValue(item)
    if (item.Expire == 1) this.setDate(item)
    this.updateItems = item;
    this.message = "บัตรกำนัล"
    this.manageGift = true
    this.updateStatus = true;
  }



  viewImage: string = ""
  uploadFile(e: any) {
    let item: GetGift = this.formGift.value;
    this.formGift.get('Image_delete').setValue(item.Image)
    this.formGift.get('Image_update').setValue(e.file)
    this.viewImage = e.base64
    if (this.viewImage) this.imageAction = true
  }


  createGift() {
    this.http.post(`gift`, this.con.paseFormData(this.formGift.value)).subscribe({
      next: (res: any) => {
        this.getGift()
        this.clearEvent()
        this.alert.notify(res.message, 'success')
      }, error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {

        this.clearEvent()
      }
    })
  }

  updateGift() {
    // https://api-dev.legitid.org/loyalty/api/
    this.http.put(`gift/${this.formGift.value['ID']}`, this.con.paseFormData(this.formGift.value)).subscribe({
      next: (res: any) => {
        this.getGift()
        this.clearEvent()
        this.alert.notify(res.message, 'success')
      }, error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {
        this.clearEvent()
      }
    })
  }

  sendGift(item: GetGift) {
    console.log(item);
    this.router.navigate(['/', AppURL.gift, 'send', item.ID])
  }

  deleteGift(item: GetGift) {
    this.alert.confirm('ต้องการลบรางวัลนี้หรือไม่').then(fm => {
      if (fm.isConfirmed) this.http.delete(`gift/${item.ID}`).subscribe({
        next: (res: any) => {
          this.getGift()
          this.clearEvent();
          this.alert.notify(res.message, 'success')
        }, error: (err) => {
          this.alert.dialog(err.error.message)
        },
        complete: () => {
          this.clearEvent()
        }
      })
    })
  }

  deduct() {

    if (this.formGift.value['Deduct'] == 0) {
      this.formGift.get('Deduct').setValue(1)
      return
    }

    else this.formGift.get('Deduct').setValue(0)
  }

  expire(v: any) {
    if (v.value == 0) {
      this.formGift.get('Expire').setValue(1)
      this.setDate(this.formGift.value)
      return
    }

    else {
      this.formGift.get('Expire').setValue(0)
      this.formGift.get('Expire_start').setValue("")
      this.formGift.get('Expire_end').setValue("")
    }
  }

  updateExpire(v: any, key: string) {
    if (key == 'start') {
      let date = moment(v).format('YYYY-MM-DD')
      this.formGift.get('Expire_start').setValue(date)
      return
    }
    if (key == 'end') {
      let date = moment(v).format('YYYY-MM-DD')
      this.formGift.get('Expire_end').setValue(date)
    }

  }



  clearEvent() {
    this.formGift.reset()
    this.message = ""
    this.updateStatus = false
    this.manageGift = false
    this.addStatus = false;
    this.updateStatus = false
    this.viewImage = ""
    this.imageAction = false
  }
}